
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
blockquote{
  --quote-text-color:var(--brand-primary-dark-blue);
  --quote-icon-background-color:var(--brand-primary-dark-blue);
  --quote-icon-border-color:transparent;

  position:relative;
  display:inline-block;
  width:-moz-fit-content;
  width:fit-content;
  display:flex;
  flex-direction:column-reverse;
  margin:0;
}

  @media (min-width: 768px){blockquote{
    display:block;
    padding-left:var(--spacing-28);
    padding-top:var(--spacing-2);
    max-width:65%
}
  }

blockquote::after{
  content:'';
  background-color:var(--quote-icon-background-color);
  background-image:url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJldS1xdW90ZSIgdmlld0JveD0iMCAwIDQ3IDMyIj48cGF0aCBjbGFzcz0iIiBkPSJNMjQuMzgxIDMybDExLjAzNS0zMmgxMS44MjJsLTguNDA3IDMyek0wIDMybDExLjI5OC0zMmgxMS41NmwtOC4xNDUgMzJ6IiBmaWxsPSIjZmZmZmZmIi8+PC9zdmc+');
  background-repeat:no-repeat;
  background-size:50%;
  background-position:center center;
  min-width:4.5rem;
  width:4.5rem;
  height:4.5rem;
  border-radius:50%;
  overflow:hidden;
  display:block;
  margin-bottom:var(--spacing-6);
  border:2px solid var(--quote-icon-border-color);
}

@media (min-width: 768px){

blockquote::after{
    position:absolute;
    top:0;
    left:0;
    margin-bottom:0
}
  }

blockquote,
blockquote p{
  font-family:var(--ff-body);
  font-style:italic;
  font-size:clamp(
    1.625rem,
    1.4519230769230769rem + 0.8653846153846154vw,
    2.1875rem
  );
  line-height:1.6;
  color:var(--quote-text-color);
}

.quote-caption{
  font-size:var(--fs-body-md);
  line-height:1.25;
  text-transform:uppercase;
  color:var(--brand-primary-dark-blue);
  font-family:var(--ff-bold);
  margin-top:var(--spacing-4);
}

@media (min-width: 768px){

.quote-caption{
    padding-left:var(--spacing-28)
}
  }

blockquote.text-align-center{
  display:block;
  margin-left:auto;
  margin-right:auto;
}

blockquote.text-align-right{
  display:block;
  margin-left:auto;
  margin-right:0;
}

blockquote::before{
  display:none;
}
`;